export function error(err, notifyNR = true) {
	if (notifyNR) {
		const newrelic = window.newrelic || window.NREUM;

		const outgoingError = typeof err === 'string' ? new Error(err) : err;
		newrelic?.noticeError?.(outgoingError, { sourceApp: 'hintsui-eval' });
	}

	console.error(err); // eslint-disable-line no-console
}

export default { error };
